import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class PaymentGatewayUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.paymentGateway(req);
    }
}
export default PaymentGatewayUseCase;
